import type {
  DataSettingsManager,
  EditorSDK,
  Logger,
  SafeUserPreferences,
} from '@wix/wix-data-client-common-standalone'
import { ensureDataModeIsEnabled } from '../enableDataMode'
import type { AppApi } from '@wix/wix-data-client-common'

export const addPresetById = async ({
  presetId,
  options,
  dataSettingsManager,
  logger,
  safeUserPreferences,
  appApi,
}: {
  presetId: string
  options: { origin: string }
  editorSdkProxy: EditorSDK
  dataSettingsManager: DataSettingsManager
  logger: Logger
  safeUserPreferences: SafeUserPreferences
  appApi: AppApi
}) => {
  const { enableDataModeTriggered } = await ensureDataModeIsEnabled({
    dataSettingsManager,
    safeUserPreferences,
    logger,
  })
  const result = await appApi.addPresetUnhandled({
    presetId,
    origin: options.origin,
    isFirstTimeExperience: enableDataModeTriggered,
  })

  return { pageRefs: result.pageRefs }
}
